import { useEffect } from "react";
import type { FC } from "react";

import Shell from "./Shell";

const AUTO_DISMISS_MS = 5000;

const GoodbyeScreen: FC<{ guestName: string; onComplete?: () => void }> = ({
  guestName,
  onComplete,
}) => {
  useEffect(() => {
    if (!onComplete) return;
    const timer = setTimeout(onComplete, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <Shell showGrid={false}>
      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
        <div className="bc-scale-in mb-8 flex size-20 items-center justify-center rounded-full border-2 border-accentGreen/30 bg-accentGreen/10 sm:size-24">
          <svg
            className="size-10 text-accentGreen sm:size-12"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </div>
        <p className="bc-fade-up bc-fade-up-1 text-sm font-medium text-white/40">
          Goodbye,
        </p>
        <h2 className="bc-fade-up bc-fade-up-2 mt-1 font-oswald text-4xl font-medium uppercase tracking-wide text-white sm:text-5xl">
          {guestName}
        </h2>
        <p className="bc-fade-up bc-fade-up-3 mt-6 max-w-xs text-sm leading-relaxed text-white/30">
          You have been checked out successfully.
          <br />
          Have a safe trip.
        </p>
      </div>
    </Shell>
  );
};

export default GoodbyeScreen;
